import React from 'react';

/**
 * ChevronExpand icon — inherits text/button color using `currentColor`.
 * https://www.svgrepo.com/svg/344645/chevron-expand
 *
 * @param size - Icon width/height in pixels (or CSS string)
 * @param color - Icon fill color (defaults to `currentColor` for inheritance)
 * @param className - Optional class name for extra styling
 * @param style - Optional inline styles
 * @param title - Accessible title for screen readers
 */
type Props = {
    size?: number | string;
    color?: string;
    className?: string;
    style?: React.CSSProperties;
    title?: string;
};

const ChevronExpand: React.FC<Props> = ({
    size = 16,
    color = 'currentColor',
    className,
    style,
    title
}) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 16 16'
        xmlns='http://www.w3.org/2000/svg'
        fill={color}
        aria-hidden={title ? undefined : true}
        role={title ? 'img' : 'presentation'}
        className={className}
        style={style}
    >
        {title ? <title>{title}</title> : null}
        <path
            fillRule='evenodd'
            d='M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z'
        />
    </svg>
);

export default ChevronExpand;
